import React, { useEffect, useState } from 'react';
import TagsPicker from 'components/TagsPicker';
import { CROP_ZONE_TAGS_FIELD, CROP_ZONE_TAGS_COLUMNS } from './constants';

const WIDE_BREAKPOINT_COLUMNS = 3;

// The accordion this section sits in pads its content by 16px on each side
// (Tailwind px-4), so this section's own width always reads 32px narrower than
// the card a person actually sees. The Figma breakpoint calls for three columns
// once that visible card reaches 920px, which is this section at 888px.
const ACCORDION_HORIZONTAL_PADDING_PX = 32;
const WIDE_BREAKPOINT_PX = 920 - ACCORDION_HORIZONTAL_PADDING_PX;

// The accordion lays its children out on a two-column grid, so a section meant to
// span the full card width has to opt out of that — same as `Editor` does.
const CropZoneTagsSection: React.FC = () => {
  const [sectionNode, setSectionNode] = useState<HTMLDivElement | null>(null);
  const [columns, setColumns] = useState(CROP_ZONE_TAGS_COLUMNS);

  useEffect(() => {
    if (!sectionNode || typeof ResizeObserver === 'undefined') {
      return undefined;
    }

    const observer = new ResizeObserver(([entry]) => {
      setColumns(
        entry.contentRect.width >= WIDE_BREAKPOINT_PX
          ? WIDE_BREAKPOINT_COLUMNS
          : CROP_ZONE_TAGS_COLUMNS
      );
    });
    observer.observe(sectionNode);
    return () => observer.disconnect();
  }, [sectionNode]);

  return (
    <div className="col-span-2" ref={setSectionNode}>
      <TagsPicker fieldName={CROP_ZONE_TAGS_FIELD} columns={columns} />
    </div>
  );
};

export default CropZoneTagsSection;
